import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { OperationResultDTO, OperationResultState, ValidationMessageType } from 'src/app/shared/Models/ResultModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { LoaderService } from './loader.service';



@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  private pendingRequests: HttpRequest<any>[] = [];
  clonedObs: any = null;
  managerPINSubscription: Subscription = new Subscription();
  constructor(private loaderService: LoaderService, private gs: GuestService) {

  }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);

  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);
    this.loaderService.isLoading.next(true);
    return new Observable<HttpEvent<any>>(observer => {
      const _subscription = next.handle(req)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {

              let isValid = true;
              isValid = this.PayloadProcesser(event.body as OperationResultDTO, req.body);

              this.removeRequest(req);
              if (isValid) {
                observer.next(event);
              }
            }
          },
          err => {
            observer.error(err);
          },
          () => {
            this.removeRequest(req);
            if (this.pendingRequests.length == 0) {
              this.clonedObs = null;
            }
            observer.complete();
          });
      return () => {
        this.removeRequest(req);
        _subscription.unsubscribe();
      };
    });

  }

  PayloadProcesser(result: OperationResultDTO, requestBody: any) {
    let isValid = true;
    if (this.gs.byPassValidation) {
      // this.gs.byPassValidation = false;

      if (!result.ExceptionMessage) {

        return isValid;

      }
    }

    const isBookingApiRequest = requestBody?.isBookingApiRequest || (requestBody instanceof Array && requestBody?.filter(y => y.isBookingApiRequest)?.length)
    
    this.gs.bShowOverbookingErrorDialog =  isBookingApiRequest && (result?.ValidationMessages?.filter(x => x.Type == ValidationMessageType.Consent).length) ? true : false;  
    if(this.gs.bShowOverbookingErrorDialog) this.gs.isOverlapErrorFromValidateCartApi = requestBody?.isValidateCartApi;

    switch (result.State) {
      case OperationResultState.Success:        
        break;

      case OperationResultState.ServerException:
        this.OnOperationCompletedWithServerError(result);
        isValid = false;
        break;

      case OperationResultState.ValidationErrors:
        this.OnOperationCompletedWithValidationErrors(result);      
        isValid = false;
        break;

      case OperationResultState.InsufficientPermissions:
        isValid = false;
        break;

      case OperationResultState.AccessDenied:
        this.OnOperationCompletedWithAccessDenied(result);
        isValid = false;
        break;
      case OperationResultState.Consent:
        if(this.gs.bShowOverbookingErrorDialog) this.OnOperationCompletedWithValidationErrors(result);
        isValid = isBookingApiRequest ? this.gs.bShowOverbookingErrorDialog : false;
        break;

    }

    
    return isValid;
  }

  OnOperationCompletedWithServerError(result: OperationResultDTO, state?) {
    this.ShowNotification(result);
  }

  OnOperationCompletedWithValidationErrors(result: OperationResultDTO, state?) {
    this.ShowNotification(result);
  }

  OnOperationCompletedWithAccessDenied(result: OperationResultDTO, state?) {
    this.ShowNotification(result, true);
  }


  ShowNotification(response: OperationResultDTO, AccessDenied?: boolean) {
    this.gs.setMessageState('', 0);
    if (response.ExceptionMessage) {
      if (!this.gs.isVersion2) {
        this.gs.setMessageState(this.gs.message.message + response.ExceptionMessage, 0);
      }
      else {
        this.gs.stopLoader();
        this.gs.openSnackBar(response.ExceptionMessage, 'CLOSE', this.gs.ConfigSettings.snackBarTime, 'large-size-snack');
      }
      return;
    }
    let validationError = '';

    if (response.ValidationMessages && response.ValidationMessages.filter(msg => (msg.Type == ValidationMessageType.Error || msg.Type == ValidationMessageType.Consent)).length > 0) {
      response.ValidationMessages.filter(msg => (msg.Type == ValidationMessageType.Error || msg.Type == ValidationMessageType.Consent)).forEach(msg => {
        if (!this.gs.isVersion2) {
          this.gs.setMessageState(this.gs.message.message + msg.Message + "\n", 0);
        }
        else {
          validationError += msg.Message + "\n";
          this.gs.stopLoader();
          this.gs.openSnackBar(validationError, 'CLOSE', this.gs.ConfigSettings.snackBarTime, 'large-size-snack');
        }
      });
    }
  }
}
